(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["currents-holdfit-cinematic"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('currents-holdfit-cinematic')) {
  customElements.define('currents-holdfit-cinematic', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = this.querySelector('form');
      this.selects = [...this.querySelectorAll('[data-variant-select]')];
      this.radios = [...this.querySelectorAll('input[name="hf-set"]')];
      this.frames = this.querySelector('.hf-frames');
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.sticky = this.querySelector('[data-sticky]');
      this.money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(n / 100);
      this.querySelectorAll('[data-thumb]').forEach(b => b.addEventListener('click', () => this.showImage(Number(b.dataset.thumb))));
      this.frames.addEventListener('scroll', () => {
        const index = Math.round(this.frames.scrollLeft / this.frames.clientWidth);
        this.thumbs.forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.thumb) === index)));
      }, { passive:true });
      this.frames.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        const index = Math.round(this.frames.scrollLeft / this.frames.clientWidth);
        this.showImage(Math.max(0, Math.min(this.thumbs.length - 1, index + (e.key === 'ArrowRight' ? 1 : -1))));
      });
      this.selects.forEach((select, i) => {
        if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) {
          const available = [...select.options].find(o => !o.disabled);
          if (available) select.value = available.value;
        }
        select.addEventListener('change', () => {
          if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(() => this.update()); else this.update();
          if (i === 0) {
            const v = this.variants.find(v => String(v.id) === select.value);
            const key = v?.title.toLowerCase().includes('brown') ? 'brown' : 'black';
            const frame = this.querySelector('[data-color="' + key + '"]');
            if (frame) this.showImage(Number(frame.dataset.frame));
            const url = new URL(window.location.href);
            url.searchParams.set('variant', select.value);
            history.replaceState({}, '', url);
          }
        });
      });
      this.radios.forEach(r => r.addEventListener('change', () => this.update()));
      this.radios[1].disabled = !this.variants.some(v => v.available);
      if (!this.radios[1].disabled) this.radios[1].checked = true;
      this.form.addEventListener('submit', e => { e.preventDefault(); this.add(); });
      this.querySelector('[data-sticky-submit]').addEventListener('click', () => this.add());
      this.querySelector('[data-choose-pair]').addEventListener('click', () => { this.radios[1].checked = true; this.update(); });
      this.observer = new IntersectionObserver(entries => { this.sticky.hidden = entries[0].isIntersecting || this.form.getBoundingClientRect().top > 0; }, { threshold:0, rootMargin:'-90px 0px 0px 0px' });
      this.observer.observe(this.form);
      this.update();
      this.setupMotion();
      this.setupVideos();
      this.setupCinematic();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.cinematicScroll);
      window.removeEventListener('resize', this.cinematicScroll);
      cancelAnimationFrame(this.cinematicFrame);
      this.motionQuery?.removeEventListener('change', this.cinematicMotionChange);
      this.observer?.disconnect(); this.revealObserver?.disconnect(); this.videoObserver?.disconnect();
      this.videos?.forEach(v => v.pause());
      if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
      if (this.motionHandler) this.motionQuery?.removeEventListener('change', this.motionHandler);
    }
    setupMotion() {
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.motionQuery.matches) {
        this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('hf-revealed'); this.revealObserver.unobserve(entry.target);
        }), { threshold:0.08 });
        this.querySelectorAll('[data-reveal]').forEach(el => {
          if (el.getBoundingClientRect().top > innerHeight) { el.classList.add('hf-reveal-ready'); this.revealObserver.observe(el); }
        });
      }
      this.querySelectorAll('a[href^="#HoldFitBuy-"]').forEach(a => a.addEventListener('click', e => {
        e.preventDefault(); this.querySelector('.hf-info').scrollIntoView({behavior:this.motionQuery.matches ? 'auto' : 'smooth'});
      }));
    }
    setupCinematic() {
      const detailTabs=[...this.querySelectorAll('[data-detail-tab]')];
      const selectDetail=tab=>{
        detailTabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
        this.querySelectorAll('[data-detail-panel]').forEach(p=>p.hidden=p.dataset.detailPanel!==tab.dataset.detailTab);
      };
      detailTabs.forEach((tab,i)=>{
        tab.addEventListener('click',()=>selectDetail(tab));
        tab.addEventListener('keydown',e=>{
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
          e.preventDefault();const index=e.key==='Home'?0:e.key==='End'?detailTabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+detailTabs.length)%detailTabs.length;
          selectDetail(detailTabs[index]);detailTabs[index].focus();
        });
      });
      const highlights=this.querySelector('[data-highlights]');
      const cards=[...highlights.children];
      const move=dir=>{
        const at=Math.round(highlights.scrollLeft/(cards[0].offsetWidth+24));
        const index=(at+dir+cards.length)%cards.length;
        highlights.scrollTo({left:cards[index].offsetLeft-cards[0].offsetLeft,behavior:this.motionQuery.matches?'auto':'smooth'});
      };
      this.querySelector('[data-highlight-prev]').addEventListener('click',()=>move(-1));
      this.querySelector('[data-highlight-next]').addEventListener('click',()=>move(1));
      highlights.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
      highlights.addEventListener('scroll',()=>{
        const x=highlights.getBoundingClientRect().left;
        const index=cards.reduce((best,c,i)=>Math.abs(c.getBoundingClientRect().left-x)<Math.abs(cards[best].getBoundingClientRect().left-x)?i:best,0);
        this.querySelector('[data-highlight-count]').textContent=String(index+1).padStart(2,'0')+' / 03';
      },{passive:true});
      this.querySelectorAll('a[href^="#HoldFit"]').forEach(a=>{
        if(a.getAttribute('href').startsWith('#HoldFitBuy-'))return;
        a.addEventListener('click',e=>{const target=this.querySelector(a.getAttribute('href'));if(target){e.preventDefault();target.scrollIntoView({behavior:this.motionQuery.matches?'auto':'smooth'});}});
      });
      const launch=this.querySelector('.hfc-launch');
      const hero=this.querySelector('.hfc-floating');
      const mark=this.querySelector('.hfc-wordmark');
      const design=this.querySelector('.hfc-design');
      const macro=this.querySelector('.hfc-macro');
      const motionButton=this.querySelector('[data-motion-toggle]');
      this.motionPaused=this.motionQuery.matches;
      const reflect=()=>{
        const off=this.motionPaused||this.motionQuery.matches;
        this.classList.toggle('hfc-motion-off',off);
        motionButton.setAttribute('aria-pressed',String(off));
        motionButton.setAttribute('aria-label',off?this.dataset.motionPlay:this.dataset.motionPause);
        motionButton.querySelector('path').setAttribute('d',off?'M7 4l9 6-9 6z':'M6 5h3v10H6zm5 0h3v10h-3z');
      };
      const render=()=>{
        this.cinematicFrame=null;
        if(this.motionPaused||this.motionQuery.matches){hero.style.transform='';mark.style.transform='';macro.style.transform='';return;}
        const r=launch.getBoundingClientRect();
        if(r.bottom>0&&r.top<innerHeight){const p=Math.max(0,Math.min(1,-r.top/r.height));hero.style.transform='translateY('+p*38+'px) scale('+(1-p*.055)+')';mark.style.transform='translateY('+p*-30+'px)';}
        const m=design.getBoundingClientRect();
        if(m.bottom>0&&m.top<innerHeight){const p=Math.max(0,Math.min(1,(innerHeight-m.top)/(innerHeight+m.height)));macro.style.transform='scale('+(1+p*.09)+')';}
      };
      this.cinematicScroll=()=>{if(!this.cinematicFrame)this.cinematicFrame=requestAnimationFrame(render);};
      window.addEventListener('scroll',this.cinematicScroll,{passive:true});
      window.addEventListener('resize',this.cinematicScroll,{passive:true});
      motionButton.addEventListener('click',()=>{this.motionPaused=!this.motionPaused;reflect();render();});
      this.cinematicMotionChange=()=>{this.motionPaused=this.motionQuery.matches;reflect();render();};
      this.motionQuery.addEventListener('change',this.cinematicMotionChange);
      reflect();render();
    }

    setupVideos() {
      this.videoTrack = this.querySelector('[data-video-track]');
      this.videos = [...this.querySelectorAll('[data-video]')];
      this.activeVideo = 0;
      if (!this.videoTrack || !this.videos.length) return;
      this.loadVideo = v => { if (!v.getAttribute('src')) { v.src = v.dataset.src + '#t=0.1'; v.load(); } };
      this.playVideo = (v, manual = false) => {
        if (!manual && (this.motionQuery.matches || v.dataset.userPaused === 'true' || document.hidden)) return;
        this.loadVideo(v);
        this.videos.forEach(other => { if (other !== v) other.pause(); });
        v.play().catch(() => {});
      };
      this.videos.forEach((v,i) => {
        const card = v.closest('[data-video-card]');
        const toggle = card.querySelector('[data-video-toggle]');
        v.controls = false;
        const reflectPlayback = () => {
          toggle.setAttribute('aria-label', v.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !v.paused);
          toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', v.paused);
          card.classList.toggle('hf-video-playing', !v.paused);
        };
        v.addEventListener('play', () => { this.videos.forEach(other => { if (other !== v) other.pause(); }); reflectPlayback(); });
        v.addEventListener('pause', reflectPlayback);
        v.addEventListener('timeupdate', () => { card.querySelector('[data-video-progress]').style.transform = 'scaleX(' + (v.duration ? v.currentTime/v.duration : 0) + ')'; });
        v.addEventListener('loadeddata', () => card.classList.add('hf-video-loaded'));
        v.addEventListener('error', () => { toggle.setAttribute('aria-label', this.dataset.retryLabel); });
        toggle.addEventListener('click', () => {
          if (v.paused) { v.dataset.userPaused = 'false'; this.activeVideo = i; this.querySelector('[data-video-count]').textContent = String(i+1).padStart(2,'0') + ' / ' + String(this.videos.length).padStart(2,'0'); this.playVideo(v,true); }
          else { v.dataset.userPaused = 'true'; v.pause(); }
        });
        v.addEventListener('click', () => toggle.click());
        reflectPlayback();
      });
      this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const v = entry.target;
        v.dataset.visible = String(entry.isIntersecting);
        if (entry.isIntersecting) { this.loadVideo(v); if (this.videos[this.activeVideo] === v) this.playVideo(v); }
        else v.pause();
      }), {threshold:0.35});
      this.videos.forEach(v => this.videoObserver.observe(v));
      const navigate = direction => {
        const width = this.videos[0].closest('[data-video-card]').offsetWidth + 16;
        const max = this.videoTrack.scrollWidth - this.videoTrack.clientWidth;
        const next = direction > 0 && this.videoTrack.scrollLeft >= max - 4 ? 0 : direction < 0 && this.videoTrack.scrollLeft <= 4 ? max : this.videoTrack.scrollLeft + width * direction;
        this.videoTrack.scrollTo({left:next,behavior:this.motionQuery.matches ? 'auto' : 'smooth'});
      };
      this.querySelector('[data-video-prev]').addEventListener('click', () => navigate(-1));
      this.querySelector('[data-video-next]').addEventListener('click', () => navigate(1));
      this.videoTrack.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); navigate(e.key === 'ArrowRight' ? 1 : -1); } });
      this.videoTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(this.videoScrollFrame);
        this.videoScrollFrame = requestAnimationFrame(() => {
          const left = this.videoTrack.getBoundingClientRect().left;
          const index = this.videos.reduce((closest,v,i) => Math.abs(v.getBoundingClientRect().left-left) < Math.abs(this.videos[closest].getBoundingClientRect().left-left) ? i : closest,0);
          this.querySelector('[data-video-count]').textContent = String(index+1).padStart(2,'0') + ' / ' + String(this.videos.length).padStart(2,'0');
          if (index !== this.activeVideo) { this.activeVideo = index; if (this.videos[index].dataset.visible === 'true') this.playVideo(this.videos[index]); }
        });
      },{passive:true});
      this.visibilityHandler = () => { if (document.hidden) this.videos.forEach(v => v.pause()); else { const v = this.videos[this.activeVideo]; if (v?.dataset.visible === 'true') this.playVideo(v); } };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.motionHandler = () => { if (this.motionQuery.matches) this.videos.forEach(v => v.pause()); };
      this.motionQuery.addEventListener('change', this.motionHandler);
    }
    showImage(index) { this.frames.scrollTo({ left:this.frames.clientWidth * index, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
    update() {
      this.count = Number(this.radios.find(r => r.checked)?.value || 1);
      this.chosen = this.selects.slice(0, this.count).map(s => this.variants.find(v => String(v.id) === s.value));
      this.available = this.chosen.every(v => v?.available);
      this.querySelector('[data-color-row="2"]').hidden = this.count !== 2;
      this.querySelector('[data-set-note]').hidden = this.count !== 2;
      this.selects.forEach((s,i) => {
        const v = this.variants.find(v => String(v.id) === s.value);
        const images = this.querySelector('.hf-colors').dataset;
        const src = v?.title.toLowerCase().includes('brown') ? images.brownImage : images.blackImage;
        this.querySelectorAll('[data-bundle-image="' + (i+1) + '"]').forEach(img => { img.removeAttribute('srcset'); img.src = src; });
      });
      const price = this.count === 2 ? this.chosen.reduce((sum,v) => sum + Math.round((v?.price || 0) * 1750 / 2499),0) : (this.chosen[0]?.price || 0);
      const label = this.available ? (this.count === 2 ? this.dataset.pairLabel : this.dataset.singleLabel) : this.dataset.unavailableLabel;
      this.querySelector('[data-submit-label]').textContent = label;
      this.querySelector('[data-sticky-label]').textContent = label;
      this.querySelector('[data-submit-price]').textContent = this.money(price);
      this.querySelector('[data-sticky-price]').textContent = this.money(price);
      this.querySelectorAll('.hf-submit,[data-sticky-submit]').forEach(b => b.disabled = !this.available || this.busy);
    }
    async add() {
      if (this.busy || !this.available) return;
      this.busy = true;
      const err = this.querySelector('[data-error]');
      const cartLink = this.querySelector('[data-error-cart]');
      err.hidden = true; cartLink.hidden = true;
      this.querySelectorAll('.hf-submit,[data-sticky-submit]').forEach(b => b.disabled = true);
      this.querySelector('[data-submit-label]').textContent = this.dataset.loadingLabel;
      this.querySelector('[data-sticky-label]').textContent = this.dataset.loadingLabel;
      const grouped = new Map();
      this.chosen.forEach(v => grouped.set(v.id, (grouped.get(v.id) || 0) + 1));
      let responseReceived = false;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', { method:'POST', headers:{ 'Content-Type':'application/json','Accept':'application/json' }, body:JSON.stringify({items:[...grouped].map(([id,quantity]) => ({id,quantity}))}) });
        responseReceived = true;
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || this.dataset.errorLabel);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        err.textContent = responseReceived ? (error.message || this.dataset.errorLabel) : this.dataset.networkLabel;
        err.hidden = false; cartLink.hidden = false;
        this.busy = false; this.update();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["currents-holdfit-final"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('currents-holdfit-final')) {
  customElements.define('currents-holdfit-final', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = this.querySelector('form');
      this.selects = [...this.querySelectorAll('[data-variant-select]')];
      this.radios = [...this.querySelectorAll('input[name="hf-set"]')];
      this.frames = this.querySelector('.hf-frames');
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.sticky = this.querySelector('[data-sticky]');
      this.money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(n / 100);
      this.querySelectorAll('[data-thumb]').forEach(b => b.addEventListener('click', () => this.showImage(Number(b.dataset.thumb))));
      this.frames.addEventListener('scroll', () => {
        const index = Math.round(this.frames.scrollLeft / this.frames.clientWidth);
        this.thumbs.forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.thumb) === index)));
      }, { passive:true });
      this.frames.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        const index = Math.round(this.frames.scrollLeft / this.frames.clientWidth);
        this.showImage(Math.max(0, Math.min(this.thumbs.length - 1, index + (e.key === 'ArrowRight' ? 1 : -1))));
      });
      this.selects.forEach((select, i) => {
        if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) {
          const available = [...select.options].find(o => !o.disabled);
          if (available) select.value = available.value;
        }
        select.addEventListener('change', () => {
          if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(() => this.update()); else this.update();
          if (i === 0) {
            const v = this.variants.find(v => String(v.id) === select.value);
            const key = v?.title.toLowerCase().includes('brown') ? 'brown' : 'black';
            const frame = this.querySelector('[data-color="' + key + '"]');
            if (frame) this.showImage(Number(frame.dataset.frame));
            const url = new URL(window.location.href);
            url.searchParams.set('variant', select.value);
            history.replaceState({}, '', url);
          }
        });
      });
      this.radios.forEach(r => r.addEventListener('change', () => this.update()));
      this.radios[1].disabled = !this.variants.some(v => v.available);
      if (!this.radios[1].disabled) this.radios[1].checked = true;
      this.form.addEventListener('submit', e => { e.preventDefault(); this.add(e.submitter || this.querySelector('.hf-submit')); });
      this.querySelector('[data-sticky-submit]').addEventListener('click', e => this.add(e.currentTarget));
      this.querySelector('[data-choose-pair]').addEventListener('click', () => { this.radios[1].checked = true; this.update(); });
      this.observer = new IntersectionObserver(entries => { this.sticky.hidden = entries[0].isIntersecting || this.form.getBoundingClientRect().top > 0; }, { threshold:0, rootMargin:'-90px 0px 0px 0px' });
      this.observer.observe(this.form);
      this.update();
      this.setupMotion();
      this.setupVideos();
      this.setupDetailFilm();
    }
    disconnectedCallback() {
      this.filmObserver?.disconnect(); this.detailVideo?.pause();
      if (this.filmVisibility) document.removeEventListener('visibilitychange', this.filmVisibility);
      if (this.filmMotion) this.motionQuery?.removeEventListener('change', this.filmMotion);
      this.observer?.disconnect(); this.revealObserver?.disconnect(); this.videoObserver?.disconnect();
      this.videos?.forEach(v => v.pause());
      if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
      if (this.motionHandler) this.motionQuery?.removeEventListener('change', this.motionHandler);
    }
    setupDetailFilm() {
      const section = this.querySelector('[data-detail-film]');
      const video = section?.querySelector('video');
      const button = section?.querySelector('[data-detail-toggle]');
      if (!video || !button || !video.dataset.src) return;
      button.hidden = false;
      let visible = false, userPaused = false;
      const reflect = () => {
        section.classList.toggle('is-playing', !video.paused || video.currentTime > 0);
        button.setAttribute('aria-label', video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        button.querySelector('[data-film-label]').textContent = video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        button.querySelector('[data-film-play]').toggleAttribute('hidden', !video.paused);
        button.querySelector('[data-film-pause]').toggleAttribute('hidden', video.paused);
      };
      const play = manual => {
        if (!manual && (this.motionQuery.matches || userPaused || document.hidden || !visible)) return;
        if (!video.src) { video.src = video.dataset.src; video.load(); }
        video.play().catch(reflect);
      };
      this.filmObserver = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) play(false); else video.pause();
      }, {threshold:.15});
      this.filmObserver.observe(section);
      button.addEventListener('click', () => { if (video.paused) { userPaused = false; play(true); } else { userPaused = true; video.pause(); } });
      video.addEventListener('play', reflect); video.addEventListener('pause', reflect);
      video.addEventListener('error', () => { section.classList.remove('is-playing'); button.hidden = true; });
      this.filmVisibility = () => { if (document.hidden) video.pause(); else play(false); };
      this.filmMotion = () => { if (this.motionQuery.matches) video.pause(); else play(false); };
      document.addEventListener('visibilitychange', this.filmVisibility);
      this.motionQuery.addEventListener('change', this.filmMotion);
      this.detailVideo = video;
      reflect();
    }

    setupMotion() {
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.motionQuery.matches) {
        this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('hf-revealed'); this.revealObserver.unobserve(entry.target);
        }), { threshold:0.08 });
        this.querySelectorAll('[data-reveal]').forEach(el => {
          if (el.getBoundingClientRect().top > innerHeight) { el.classList.add('hf-reveal-ready'); this.revealObserver.observe(el); }
        });
      }
      this.querySelectorAll('a[href^="#HoldFitBuy-"]').forEach(a => a.addEventListener('click', e => {
        e.preventDefault(); this.querySelector('.hf-hero').scrollIntoView({behavior:this.motionQuery.matches ? 'auto' : 'smooth'});
      }));
    }
    setupVideos() {
      this.videoTrack = this.querySelector('[data-video-track]');
      this.videos = [...this.querySelectorAll('[data-video]')];
      this.activeVideo = 0;
      if (!this.videoTrack || !this.videos.length) return;
      this.loadVideo = v => { if (!v.getAttribute('src')) { v.src = v.dataset.src + '#t=0.1'; v.load(); } };
      this.playVideo = (v, manual = false) => {
        if (!manual && (this.motionQuery.matches || v.dataset.userPaused === 'true' || document.hidden)) return;
        this.loadVideo(v);
        this.videos.forEach(other => { if (other !== v) other.pause(); });
        v.play().catch(() => {});
      };
      this.videos.forEach((v,i) => {
        const card = v.closest('[data-video-card]');
        const toggle = card.querySelector('[data-video-toggle]');
        v.controls = false;
        const reflectPlayback = () => {
          toggle.setAttribute('aria-label', v.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !v.paused);
          toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', v.paused);
          card.classList.toggle('hf-video-playing', !v.paused);
        };
        v.addEventListener('play', () => { this.videos.forEach(other => { if (other !== v) other.pause(); }); reflectPlayback(); });
        v.addEventListener('pause', reflectPlayback);
        v.addEventListener('timeupdate', () => { card.querySelector('[data-video-progress]').style.transform = 'scaleX(' + (v.duration ? v.currentTime/v.duration : 0) + ')'; });
        v.addEventListener('loadeddata', () => card.classList.add('hf-video-loaded'));
        v.addEventListener('error', () => { toggle.setAttribute('aria-label', this.dataset.retryLabel); });
        toggle.addEventListener('click', () => {
          if (v.paused) { v.dataset.userPaused = 'false'; this.activeVideo = i; this.querySelector('[data-video-count]').textContent = String(i+1).padStart(2,'0') + ' / ' + String(this.videos.length).padStart(2,'0'); this.playVideo(v,true); }
          else { v.dataset.userPaused = 'true'; v.pause(); }
        });
        v.addEventListener('click', () => toggle.click());
        reflectPlayback();
      });
      this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const v = entry.target;
        v.dataset.visible = String(entry.isIntersecting);
        if (entry.isIntersecting) { this.loadVideo(v); if (this.videos[this.activeVideo] === v) this.playVideo(v); }
        else v.pause();
      }), {threshold:0.35});
      this.videos.forEach(v => this.videoObserver.observe(v));
      const navigate = direction => {
        const width = this.videos[0].closest('[data-video-card]').offsetWidth + 16;
        const max = this.videoTrack.scrollWidth - this.videoTrack.clientWidth;
        const next = direction > 0 && this.videoTrack.scrollLeft >= max - 4 ? 0 : direction < 0 && this.videoTrack.scrollLeft <= 4 ? max : this.videoTrack.scrollLeft + width * direction;
        this.videoTrack.scrollTo({left:next,behavior:this.motionQuery.matches ? 'auto' : 'smooth'});
      };
      this.querySelector('[data-video-prev]').addEventListener('click', () => navigate(-1));
      this.querySelector('[data-video-next]').addEventListener('click', () => navigate(1));
      this.videoTrack.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); navigate(e.key === 'ArrowRight' ? 1 : -1); } });
      this.videoTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(this.videoScrollFrame);
        this.videoScrollFrame = requestAnimationFrame(() => {
          const left = this.videoTrack.getBoundingClientRect().left;
          const index = this.videos.reduce((closest,v,i) => Math.abs(v.getBoundingClientRect().left-left) < Math.abs(this.videos[closest].getBoundingClientRect().left-left) ? i : closest,0);
          this.querySelector('[data-video-count]').textContent = String(index+1).padStart(2,'0') + ' / ' + String(this.videos.length).padStart(2,'0');
          if (index !== this.activeVideo) { this.activeVideo = index; if (this.videos[index].dataset.visible === 'true') this.playVideo(this.videos[index]); }
        });
      },{passive:true});
      this.visibilityHandler = () => { if (document.hidden) this.videos.forEach(v => v.pause()); else { const v = this.videos[this.activeVideo]; if (v?.dataset.visible === 'true') this.playVideo(v); } };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.motionHandler = () => { if (this.motionQuery.matches) this.videos.forEach(v => v.pause()); };
      this.motionQuery.addEventListener('change', this.motionHandler);
    }
    showImage(index) { this.frames.scrollTo({ left:this.frames.clientWidth * index, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
    update() {
      this.count = Number(this.radios.find(r => r.checked)?.value || 1);
      this.chosen = this.selects.slice(0, this.count).map(s => this.variants.find(v => String(v.id) === s.value));
      this.available = this.chosen.every(v => v?.available);
      this.querySelector('[data-color-row="2"]').hidden = this.count !== 2;
      this.querySelector('[data-set-note]').hidden = this.count !== 2;
      this.selects.forEach((s,i) => {
        const v = this.variants.find(v => String(v.id) === s.value);
        const images = this.querySelector('.hf-colors').dataset;
        const src = v?.title.toLowerCase().includes('brown') ? images.brownImage : images.blackImage;
        this.querySelectorAll('[data-bundle-image="' + (i+1) + '"]').forEach(img => { img.removeAttribute('srcset'); img.src = src; });
      });
      const price = this.count === 2 ? this.chosen.reduce((sum,v) => sum + Math.round((v?.price || 0) * 1750 / 2499),0) : (this.chosen[0]?.price || 0);
      const label = this.available ? (this.count === 2 ? this.dataset.pairLabel : this.dataset.singleLabel) : this.dataset.unavailableLabel;
      this.querySelector('[data-submit-label]').textContent = label;
      this.querySelector('[data-sticky-label]').textContent = label;
      this.querySelector('[data-submit-price]').textContent = this.money(price);
      this.querySelector('[data-sticky-price]').textContent = this.money(price);
      this.querySelectorAll('.hf-submit,[data-sticky-submit]').forEach(b => b.disabled = !this.available || this.busy);
    }
    async add(trigger) {
      if (this.busy || !this.available) return;
      this.busy = true;
      const err = this.querySelector('[data-error]');
      const cartLink = this.querySelector('[data-error-cart]');
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender ? drawer.getSectionsToRender().map(section => section.id) : ['cart-drawer', 'cart-icon-bubble'];
      drawer?.setActiveElement?.(trigger);
      err.hidden = true; cartLink.hidden = true;
      this.form.setAttribute('aria-busy', 'true');
      this.querySelectorAll('.hf-submit,[data-sticky-submit]').forEach(b => b.disabled = true);
      this.querySelector('[data-submit-label]').textContent = this.dataset.loadingLabel;
      this.querySelector('[data-sticky-label]').textContent = this.dataset.loadingLabel;
      const grouped = new Map();
      this.chosen.forEach(v => grouped.set(v.id, (grouped.get(v.id) || 0) + 1));
      let responseReceived = false, added = false;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [...grouped].map(([id,quantity]) => ({id,quantity})), sections, sections_url: location.pathname })
        });
        responseReceived = true;
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.dataset.errorLabel);
        added = true;
        if (drawer?.renderContents) {
          // A section rendering failure must never repeat the cart addition.
          if (!sections.every(id => data.sections?.[id])) {
            const url = new URL(location.pathname, location.origin);
            url.searchParams.set('sections', sections.join(','));
            const sectionResponse = await fetch(url, {headers: {'Accept': 'application/json'}});
            if (!sectionResponse.ok) throw new Error(this.dataset.networkLabel);
            data.sections = await sectionResponse.json();
          }
          if (!sections.every(id => data.sections?.[id])) throw new Error(this.dataset.networkLabel);
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          document.dispatchEvent(new CustomEvent('cart:updated', {detail: {source: 'currents-holdfit-final'}}));
        } else {
          window.location.assign(this.dataset.cartUrl);
        }
      } catch (error) {
        if (added) {
          // Preserve a successful addition even if a third-party cart renderer fails.
          window.location.assign(this.dataset.cartUrl);
        } else {
          err.textContent = responseReceived ? (error.message || this.dataset.errorLabel) : this.dataset.networkLabel;
          err.hidden = false; cartLink.hidden = false;
          err.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
      } finally {
        this.busy = false;
        this.form.removeAttribute('aria-busy');
        this.update();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["currents-holdfit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('currents-holdfit')) {
  customElements.define('currents-holdfit', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = this.querySelector('form');
      this.selects = [...this.querySelectorAll('[data-variant-select]')];
      this.radios = [...this.querySelectorAll('input[name="hf-set"]')];
      this.frames = this.querySelector('.hf-frames');
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.sticky = this.querySelector('[data-sticky]');
      this.money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(n / 100);
      this.querySelectorAll('[data-thumb]').forEach(b => b.addEventListener('click', () => this.showImage(Number(b.dataset.thumb))));
      this.frames.addEventListener('scroll', () => {
        const index = Math.round(this.frames.scrollLeft / this.frames.clientWidth);
        this.thumbs.forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.thumb) === index)));
      }, { passive:true });
      this.frames.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        const index = Math.round(this.frames.scrollLeft / this.frames.clientWidth);
        this.showImage(Math.max(0, Math.min(this.thumbs.length - 1, index + (e.key === 'ArrowRight' ? 1 : -1))));
      });
      this.selects.forEach((select, i) => {
        if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) {
          const available = [...select.options].find(o => !o.disabled);
          if (available) select.value = available.value;
        }
        select.addEventListener('change', () => {
          if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(() => this.update()); else this.update();
          if (i === 0) {
            const v = this.variants.find(v => String(v.id) === select.value);
            const key = v?.title.toLowerCase().includes('brown') ? 'brown' : 'black';
            const frame = this.querySelector('[data-color="' + key + '"]');
            if (frame) this.showImage(Number(frame.dataset.frame));
            const url = new URL(window.location.href);
            url.searchParams.set('variant', select.value);
            history.replaceState({}, '', url);
          }
        });
      });
      this.radios.forEach(r => r.addEventListener('change', () => this.update()));
      this.radios[1].disabled = !this.variants.some(v => v.available);
      if (!this.radios[1].disabled) this.radios[1].checked = true;
      this.form.addEventListener('submit', e => { e.preventDefault(); this.add(); });
      this.querySelector('[data-sticky-submit]').addEventListener('click', () => this.add());
      this.querySelector('[data-choose-pair]').addEventListener('click', () => { this.radios[1].checked = true; this.update(); });
      this.observer = new IntersectionObserver(entries => { this.sticky.hidden = entries[0].isIntersecting || this.form.getBoundingClientRect().top > 0; }, { threshold:0, rootMargin:'-90px 0px 0px 0px' });
      this.observer.observe(this.form);
      this.update();
      this.setupMotion();
      this.setupVideos();
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.revealObserver?.disconnect(); this.videoObserver?.disconnect();
      this.videos?.forEach(v => v.pause());
      if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
      if (this.motionHandler) this.motionQuery?.removeEventListener('change', this.motionHandler);
    }
    setupMotion() {
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.motionQuery.matches) {
        this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('hf-revealed'); this.revealObserver.unobserve(entry.target);
        }), { threshold:0.08 });
        this.querySelectorAll('[data-reveal]').forEach(el => {
          if (el.getBoundingClientRect().top > innerHeight) { el.classList.add('hf-reveal-ready'); this.revealObserver.observe(el); }
        });
      }
      this.querySelectorAll('a[href^="#HoldFitBuy-"]').forEach(a => a.addEventListener('click', e => {
        e.preventDefault(); this.querySelector('.hf-hero').scrollIntoView({behavior:this.motionQuery.matches ? 'auto' : 'smooth'});
      }));
    }
    setupVideos() {
      this.videoTrack = this.querySelector('[data-video-track]');
      this.videos = [...this.querySelectorAll('[data-video]')];
      this.activeVideo = 0;
      if (!this.videoTrack || !this.videos.length) return;
      this.loadVideo = v => { if (!v.getAttribute('src')) { v.src = v.dataset.src + '#t=0.1'; v.load(); } };
      this.playVideo = (v, manual = false) => {
        if (!manual && (this.motionQuery.matches || v.dataset.userPaused === 'true' || document.hidden)) return;
        this.loadVideo(v);
        this.videos.forEach(other => { if (other !== v) other.pause(); });
        v.play().catch(() => {});
      };
      this.videos.forEach((v,i) => {
        const card = v.closest('[data-video-card]');
        const toggle = card.querySelector('[data-video-toggle]');
        v.controls = false;
        const reflectPlayback = () => {
          toggle.setAttribute('aria-label', v.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !v.paused);
          toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', v.paused);
          card.classList.toggle('hf-video-playing', !v.paused);
        };
        v.addEventListener('play', () => { this.videos.forEach(other => { if (other !== v) other.pause(); }); reflectPlayback(); });
        v.addEventListener('pause', reflectPlayback);
        v.addEventListener('timeupdate', () => { card.querySelector('[data-video-progress]').style.transform = 'scaleX(' + (v.duration ? v.currentTime/v.duration : 0) + ')'; });
        v.addEventListener('loadeddata', () => card.classList.add('hf-video-loaded'));
        v.addEventListener('error', () => { toggle.setAttribute('aria-label', this.dataset.retryLabel); });
        toggle.addEventListener('click', () => {
          if (v.paused) { v.dataset.userPaused = 'false'; this.activeVideo = i; this.querySelector('[data-video-count]').textContent = String(i+1).padStart(2,'0') + ' / ' + String(this.videos.length).padStart(2,'0'); this.playVideo(v,true); }
          else { v.dataset.userPaused = 'true'; v.pause(); }
        });
        v.addEventListener('click', () => toggle.click());
        reflectPlayback();
      });
      this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const v = entry.target;
        v.dataset.visible = String(entry.isIntersecting);
        if (entry.isIntersecting) { this.loadVideo(v); if (this.videos[this.activeVideo] === v) this.playVideo(v); }
        else v.pause();
      }), {threshold:0.35});
      this.videos.forEach(v => this.videoObserver.observe(v));
      const navigate = direction => {
        const width = this.videos[0].closest('[data-video-card]').offsetWidth + 16;
        const max = this.videoTrack.scrollWidth - this.videoTrack.clientWidth;
        const next = direction > 0 && this.videoTrack.scrollLeft >= max - 4 ? 0 : direction < 0 && this.videoTrack.scrollLeft <= 4 ? max : this.videoTrack.scrollLeft + width * direction;
        this.videoTrack.scrollTo({left:next,behavior:this.motionQuery.matches ? 'auto' : 'smooth'});
      };
      this.querySelector('[data-video-prev]').addEventListener('click', () => navigate(-1));
      this.querySelector('[data-video-next]').addEventListener('click', () => navigate(1));
      this.videoTrack.addEventListener('keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); navigate(e.key === 'ArrowRight' ? 1 : -1); } });
      this.videoTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(this.videoScrollFrame);
        this.videoScrollFrame = requestAnimationFrame(() => {
          const left = this.videoTrack.getBoundingClientRect().left;
          const index = this.videos.reduce((closest,v,i) => Math.abs(v.getBoundingClientRect().left-left) < Math.abs(this.videos[closest].getBoundingClientRect().left-left) ? i : closest,0);
          this.querySelector('[data-video-count]').textContent = String(index+1).padStart(2,'0') + ' / ' + String(this.videos.length).padStart(2,'0');
          if (index !== this.activeVideo) { this.activeVideo = index; if (this.videos[index].dataset.visible === 'true') this.playVideo(this.videos[index]); }
        });
      },{passive:true});
      this.visibilityHandler = () => { if (document.hidden) this.videos.forEach(v => v.pause()); else { const v = this.videos[this.activeVideo]; if (v?.dataset.visible === 'true') this.playVideo(v); } };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.motionHandler = () => { if (this.motionQuery.matches) this.videos.forEach(v => v.pause()); };
      this.motionQuery.addEventListener('change', this.motionHandler);
    }
    showImage(index) { this.frames.scrollTo({ left:this.frames.clientWidth * index, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
    update() {
      this.count = Number(this.radios.find(r => r.checked)?.value || 1);
      this.chosen = this.selects.slice(0, this.count).map(s => this.variants.find(v => String(v.id) === s.value));
      this.available = this.chosen.every(v => v?.available);
      this.querySelector('[data-color-row="2"]').hidden = this.count !== 2;
      this.querySelector('[data-set-note]').hidden = this.count !== 2;
      this.selects.forEach((s,i) => {
        const v = this.variants.find(v => String(v.id) === s.value);
        const images = this.querySelector('.hf-colors').dataset;
        const src = v?.title.toLowerCase().includes('brown') ? images.brownImage : images.blackImage;
        this.querySelectorAll('[data-bundle-image="' + (i+1) + '"]').forEach(img => { img.removeAttribute('srcset'); img.src = src; });
      });
      const price = this.count === 2 ? this.chosen.reduce((sum,v) => sum + Math.round((v?.price || 0) * 1750 / 2499),0) : (this.chosen[0]?.price || 0);
      const label = this.available ? (this.count === 2 ? this.dataset.pairLabel : this.dataset.singleLabel) : this.dataset.unavailableLabel;
      this.querySelector('[data-submit-label]').textContent = label;
      this.querySelector('[data-sticky-label]').textContent = label;
      this.querySelector('[data-submit-price]').textContent = this.money(price);
      this.querySelector('[data-sticky-price]').textContent = this.money(price);
      this.querySelectorAll('.hf-submit,[data-sticky-submit]').forEach(b => b.disabled = !this.available || this.busy);
    }
    async add() {
      if (this.busy || !this.available) return;
      this.busy = true;
      const err = this.querySelector('[data-error]');
      const cartLink = this.querySelector('[data-error-cart]');
      err.hidden = true; cartLink.hidden = true;
      this.querySelectorAll('.hf-submit,[data-sticky-submit]').forEach(b => b.disabled = true);
      this.querySelector('[data-submit-label]').textContent = this.dataset.loadingLabel;
      this.querySelector('[data-sticky-label]').textContent = this.dataset.loadingLabel;
      const grouped = new Map();
      this.chosen.forEach(v => grouped.set(v.id, (grouped.get(v.id) || 0) + 1));
      let responseReceived = false;
      try {
        const response = await fetch(this.dataset.addUrl + '.js', { method:'POST', headers:{ 'Content-Type':'application/json','Accept':'application/json' }, body:JSON.stringify({items:[...grouped].map(([id,quantity]) => ({id,quantity}))}) });
        responseReceived = true;
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || this.dataset.errorLabel);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        err.textContent = responseReceived ? (error.message || this.dataset.errorLabel) : this.dataset.networkLabel;
        err.hidden = false; cartLink.hidden = false;
        this.busy = false; this.update();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["currents-lace"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('currents-lace')) {
  customElements.define('currents-lace', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-option]');
        if (option && !event.ctrlKey && !event.metaKey && !event.shiftKey) { event.preventDefault(); this.selectVariant(option); }
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) this.showImage(Number(thumb.dataset.thumb));
        const arrow = event.target.closest('[data-gallery-step]');
        if (arrow) this.showImage((this.imageIndex || 0) + Number(arrow.dataset.galleryStep));
        if (event.target.closest('[data-open-size]')) this.querySelector('.sl-size-dialog').showModal();
        if (event.target.closest('[data-close-dialog]')) event.target.closest('dialog').close();
        if (event.target.tagName === 'DIALOG' && event.target === event.currentTarget) event.target.close();
      });
      this.addEventListener('keydown', event => {
        if (event.target.closest('.sl-gallery') && ['ArrowLeft','ArrowRight'].includes(event.key)) {
          event.preventDefault(); this.showImage((this.imageIndex || 0) + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.addEventListener('submit', event => { if (event.target.matches('.sl-product-form')) this.addToCart(event); });
      this.bindGallery();
      this.setupBundle();
      this.addEventListener('change', event => { if (event.target.matches('[data-bundle-toggle], [data-bundle-style], [data-bundle-size]')) this.updateBundle(); });
      this.onPop = () => this.selectVariant({href:location.href, dataset:{}}, false);
      window.addEventListener('popstate', this.onPop);
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPop); this.controller?.abort(); this.ready = false; }
    bindGallery() {
      const slides = this.querySelector('.sl-slides');
      if (!slides) return;
      this.imageIndex = 0;
      slides.addEventListener('scroll', () => {
        this.imageIndex = Math.round(slides.scrollLeft / slides.clientWidth);
        this.querySelectorAll('[data-thumb]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.thumb) === this.imageIndex)));
      }, {passive:true});
    }
    showImage(index) {
      const slides = this.querySelector('.sl-slides');
      const count = slides.children.length;
      this.imageIndex = (index + count) % count;
      slides.scrollTo({left: slides.clientWidth * this.imageIndex, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    async selectVariant(option, push = true) {
      const sourceAnchor = option.dataset.compare ? this.querySelector('.sl-compare') : this.querySelector('.sl-style-options');
      const optionTop = sourceAnchor.getBoundingClientRect().top;
      const bundleState = this.bundleState();
      this.controller?.abort();
      this.controller = new AbortController();
      const url = new URL(option.href, location.origin);
      new URL(location.href).searchParams.forEach((value,key)=>{ if (key.startsWith('utm_') || ['fbclid','gclid','preview_theme_id'].includes(key)) url.searchParams.set(key,value); });
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', this.dataset.section);
      this.setAttribute('aria-busy','true');
      this.querySelector('.sl-add').disabled = true;
      try {
        const response = await fetch(fetchUrl.toString(), {signal:this.controller.signal});
        if (!response.ok) throw new Error('Variant unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.querySelector('currents-lace');
        if (!next) throw new Error('Missing product');
        const sameStyle = this.dataset.style === next.dataset.style;
        const oldImage = this.imageIndex || 0;
        this.querySelectorAll('video').forEach(video=>video.pause());
        this.innerHTML = next.innerHTML;
        this.dataset.style = next.dataset.style;
        this.dataset.variant = next.dataset.variant;
        this.dataset.updated = 'true';
        this.bindGallery();
        this.setupBundle(bundleState);
        requestAnimationFrame(() => window.scrollBy({top:(option.dataset.compare ? this.querySelector('.sl-compare') : this.querySelector('.sl-style-options')).getBoundingClientRect().top - optionTop,behavior:'instant'}));
        if (sameStyle) this.showImage(oldImage);
        if (push) history.pushState({}, '', url);
        if (option.dataset.option) this.querySelector(`[data-option="${option.dataset.option}"]`)?.focus({preventScroll:true});
        document.title = this.dataset.pageTitle || document.title;
      } catch (error) {
        if (error.name !== 'AbortError') { console.warn('Currents variant rendering:', error.message); location.assign(url); }
      } finally { this.removeAttribute('aria-busy'); }
    }

    bundleState() {
      return {checked:!!this.querySelector('[data-bundle-toggle]')?.checked, style:this.querySelector('[data-bundle-style]')?.value, size:this.querySelector('[data-bundle-size]')?.value};
    }
    setupBundle(state) {
      this.variants = JSON.parse(this.querySelector('[data-lace-variants]').textContent);
      if (state?.checked && this.querySelector('[data-bundle-toggle]')) {
        this.querySelector('[data-bundle-toggle]').checked = true;
        this.querySelector('[data-bundle-style]').value = state.style;
        this.querySelector('[data-bundle-size]').value = state.size;
      }
      this.updateBundle();
    }
    updateBundle() {
      const state = this.bundleState();
      const current = this.variants.find(v=>String(v.id)===this.dataset.variant);
      const second = this.variants.find(v=>v.style===state.style && v.size===state.size);
      const button = this.querySelector('.sl-product-form [name="add"]');
      const box = this.querySelector('.sl-bundle-options');
      if (box) box.hidden = !state.checked;
      this.querySelector('[data-bundle-toggle]')?.setAttribute('aria-expanded',String(state.checked));
      this.querySelectorAll('[data-bundle-size] option').forEach(option=>{
        const item=this.variants.find(v=>v.style===state.style && v.size===option.value);
        option.disabled=!item?.available;
      });
      if (state.checked && second) {
        const savings = Math.floor(Math.min(current.price, second.price)*0.5);
        const money = amount=>new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.dataset.currency}).format(amount/100);
        const setMoney = (sel, amt) => { const el = this.querySelector(sel); if (el) el.innerHTML = '<span class="money">' + money(amt) + '</span>'; };
        setMoney('[data-bundle-total]', current.price + second.price - savings);
        setMoney('[data-bundle-saving]', savings);
        if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') window.bucksCC.reConvert();
      }
      const available = current?.available && (!state.checked || second?.available);
      const error=this.querySelector('[data-bundle-error]');
      if(error) error.textContent=state.checked && !second?.available ? this.dataset.unavailable : '';
      button.disabled=!available;
      button.textContent=state.checked ? this.dataset.addBoth : button.dataset.singleLabel;
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.hasAttribute('aria-busy') || this.cartAdding) return;
      const form = event.target;
      const button = form.querySelector('[name="add"]');
      if (button.disabled) return;
      const status = form.querySelector('[role="status"].sl-form-status');
      const label = button.textContent;
      const state = this.bundleState();
      const second = this.variants.find(v=>v.style===state.style && v.size===state.size);
      const items=[{id:this.dataset.variant,quantity:1}];
      if(state.checked && second?.available) {
        if(String(second.id)===this.dataset.variant) items[0].quantity=2;
        else items.push({id:String(second.id),quantity:1});
      }
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender ? drawer.getSectionsToRender().map(section=>section.id) : ['cart-drawer','cart-icon-bubble'];
      drawer?.setActiveElement?.(button);
      this.cartAdding=true;
      button.disabled = true;
      button.textContent = status.dataset.adding;
      status.textContent = '';
      let added=false;
      try {
        const response = await fetch(this.dataset.cartAdd + '.js', {method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items,sections,sections_url:location.pathname})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || status.dataset.error);
        added=true;
        status.textContent = status.dataset.added;
        if (drawer?.renderContents && sections.every(id=>result.sections?.[id])) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
          document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'currents-lace'}}));
        } else {
          location.assign(this.dataset.cartUrl);
        }
      } catch (error) {
        if(added) location.assign(this.dataset.cartUrl);
        else status.textContent = error.message || status.dataset.error;
      } finally {
        this.cartAdding=false;
        button.textContent=label;
        this.updateBundle();
      }
    }

  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-backup-20251114-161605"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Add minimum scroll delta threshold to reduce flickering
      const scrollDelta = Math.abs(scrollTop - this.currentScrollTop);
      if (scrollDelta < 5) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
